import gql from 'graphql-tag';

export default gql ` 
query getActivity($id: ID!){
    getActivity(id: $id){
        id
        actDate
        username
        activityType
        value
        intensity
        notes
        timestamp
    }
}`;


// WEBPACK FOOTER //
// ./src/components/queries/GetActivityQuery.js